var EstimateDeliveryPriceView = (function (BaseView) {

    var storageName = 'userPostCode';

    return BaseView.extend({
        el: '@estimateDeliveryPrice',

        _hiddenClass: 'hidden-block',

        events: {
            'click @estimateSubmint': '_submin',
            'click @estimatePostcode': '_showButton'
        },

        initialize: function () {
            _.bindAll(this, '_toggle', '_submin', '_showButton', '_hideButton');
            this.listenTo(this.model, 'change', this._toggle);
        },

        _toggle: function (m) {
            var _settings = CheckoutSettings.getBasketSettings();
            var summaryModel = m.get('Summary');
            var estimatePostcode = summaryModel.get('EstimateShipmentPostcode');
            if (estimatePostcode) {
                var postcodeModel = this._getPostcodeModel();
                postcodeModel && postcodeModel.set('Value', estimatePostcode, { silent: true });
            }

            var _deliveryModel = m.get('Delivery');
            var _basketMode = m.get('BasketMode');
            var _hasCurrentAddress = false;

            if (_basketMode === 0) {
                _hasCurrentAddress = _deliveryModel.get('Current').get('ID');
            } else {
                _hasCurrentAddress = _deliveryModel.get('CurrentGiftAddress').get('ID');
            }

            this.$el.toggleClass('hidden-block', !!(_settings.ShippingByPostcodeEnabled !== true || _hasCurrentAddress));
            this._setCurrentValue();
        },

        _showButton: function () {
            this.$('@estimateSubmint').removeClass(this._hiddenClass);
            this.$('@estimatePostcode').addClass('estimate-shipping-postcode__active');
            this.$('@estimatePostcode').removeClass('estimate-shipping-postcode');
            this.$('@estimateTick').addClass(this._hiddenClass);
        },

        _hideButton: function () {
            this.$('@estimateSubmint').addClass(this._hiddenClass);
            this.$('@estimatePostcode').removeClass('estimate-shipping-postcode__active');
            this.$('@estimatePostcode').addClass('estimate-shipping-postcode');
            this.$('@estimateTick').removeClass(this._hiddenClass);
        },

        _setCurrentValue: function () {
            var postcodeModel = this._getPostcodeModel();
            var postcode = postcodeModel && postcodeModel.get('Value');
            if (!postcode && window.localStorage) {
                var usepostcode = ((JSON.parse(localStorage.getItem(storageName)) || '') + '') || null;
                postcode = usepostcode || '';
            }

            this.$field = this.$('input');
            this.$('input').val(postcode);

            if (postcodeModel) {
                this.$('input').keyFilter(postcodeModel.get('MaxLength'), postcodeModel.get('Regexp'));
            }

            if (postcode) {
                this._hideButton();
            }
        },

        _getPostcodeModel: function () {
            return this.model.get('Delivery').get('Form').where({ Name: 'Postcode' })[0];
        },

        _submin: function () {
            var postcode = this.$field && this.$field.val();
            if (postcode) {
                var postcodeModel = this._getPostcodeModel();
                postcodeModel && postcodeModel.setValue(postcode);
                
                if (postcodeModel.isValid()) {
                    var _update = this.model._updateCheckout;
                    var _this = this;
                    if (window.localStorage) {
                        localStorage.setItem(storageName, JSON.stringify(postcode.toString()));
                    }
                    api.getPrices({ Postcode: postcode, PickupPoint: '' }).done(function (data) {
                        _update(data);
                        postcodeModel && postcodeModel.setValue(postcode);
                        _this._hideButton();
                    });
                }
            }
        }
    });

})(BaseView);